export default "__VITE_ASSET__Di6pbJx8__"